import { render } from "./DailyTipBlock.vue?vue&type=template&id=2952bdf6"
import script from "./DailyTipBlock.vue?vue&type=script&lang=js"
export * from "./DailyTipBlock.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__